var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "right", title: "", width: "150", trigger: "click" },
    },
    [
      _c("i", {
        staticClass: "icon iconfont icon-xuanfu",
        staticStyle: {
          "margin-left": "4px",
          cursor: "pointer",
          "font-size": "14px",
        },
        attrs: { slot: "reference", title: _vm.$t("chart.layer_controller") },
        slot: "reference",
      }),
      _c("div", [
        _c(
          "ul",
          { staticClass: "de-ul", staticStyle: { padding: "0px !important" } },
          _vm._l(_vm.layerOption, function (node, i) {
            return _c(
              "li",
              {
                key: node.id,
                staticClass: "de-sort-field-span",
                class: _vm.currentSeriesId === node.id ? "de-active-li" : "",
                attrs: { index: i },
                on: {
                  click: function ($event) {
                    return _vm.changeSeries(node)
                  },
                },
              },
              [
                _c("span", { attrs: { title: node.name } }, [
                  _vm._v(_vm._s(node.name)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }